import QuoteSidebar from '../components/QuoteSidebar';
import QuoteOpenButton from '../components/FloatingQuoteButton';
import SingleProductQuoteButton from '../components/SingleProductQuoteButton';
import QuoteButton from '../components/QuoteButton';
import Portal from '../components/Portal';

const FrontendApp = () => {
  return (
    <>
      <QuoteOpenButton />
      <QuoteSidebar />

      {/* SINGLE PRODUCT BUTTONS */}
      {document.querySelectorAll('.mctqfw-single-product-btn').length > 0 &&
        Array.from(
          document.querySelectorAll('.mctqfw-single-product-btn')
        ).map((el, i) => (
          <Portal key={i} target={el}>
            <SingleProductQuoteButton
              productId={el.dataset.productId}
            />
          </Portal>
        ))
      }

      {/* SHOP LOOP BUTTONS */}
      {document.querySelectorAll('.mctqfw-shop-quote-btn').length > 0 &&
        Array.from(
          document.querySelectorAll('.mctqfw-shop-quote-btn')
        ).map((el, i) => (
          <Portal key={i} target={el}>
            <QuoteButton
              productId={el.dataset.productId}
            />
          </Portal>
        ))
      }
    </>
  );
};

export default FrontendApp;

